import { useRecentEditedLoads } from '../../features/organization/api';
import type { RecentEditedLoad } from '../../features/organization/api';
import { STATUS_OPTIONS } from '../../features/org-orders/manageLoadForm';

const statusLabel = (status: string) =>
  STATUS_OPTIONS.find((option) => option.value === status)?.label ?? status;

export function RecentLoadsTab({
  active,
  onOpenLoad,
}: {
  /** Only fetches while its tab is showing. */
  active: boolean;
  onOpenLoad: (load: RecentEditedLoad) => void;
}) {
  const q = useRecentEditedLoads({ limit: 25, enabled: active });
  const loads = q.data?.loads ?? [];

  if (q.isLoading) return <div className="skeleton" style={{ height: 240 }} />;
  if (q.isError) return <div className="banner banner--warn">Failed to load recent loads.</div>;
  if (loads.length === 0) return <div className="muted">No loads have been edited yet.</div>;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      {loads.map((load) => (
        <div key={load.itemId} className="card" style={{ padding: 12 }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              gap: 10,
              alignItems: 'center',
            }}
          >
            <div style={{ minWidth: 0, flex: '1 1 auto' }}>
              <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                <button
                  type="button"
                  className="btn btn--link"
                  onClick={() => onOpenLoad(load)}
                  style={{ fontWeight: 700, padding: 0 }}
                >
                  {load.loadNumber || `Item ${load.itemId.slice(-6)}`}
                </button>
                <span
                  style={{
                    border: '1px solid #e5e7eb',
                    background: '#f3f4f6',
                    padding: '2px 8px',
                    borderRadius: 999,
                    fontSize: 12,
                    fontWeight: 700,
                  }}
                >
                  {statusLabel(load.status)}
                </span>
              </div>

              <div className="muted tiny" style={{ marginTop: 4 }}>
                {[load.customerName, load.productName].filter(Boolean).join(' · ') || '—'}
              </div>

              <div className="muted tiny" style={{ marginTop: 4 }}>
                {new Date(load.lastEditedAt).toLocaleString()}
                {load.lastActor ? ` · ${load.lastActor}` : ''}
              </div>
            </div>

            <button
              className="btn btn--ghost"
              onClick={() => onOpenLoad(load)}
              style={{ flex: '0 0 auto', whiteSpace: 'nowrap', height: 36 }}
            >
              Open load
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
